/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Code_TitleInputs */

const en_mk_tb_code_title = /** @type {(inputs: Mk_Tb_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue an existing codebase`)
};

const id_mk_tb_code_title = /** @type {(inputs: Mk_Tb_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanjutkan codebase yang ada`)
};

/**
* | output |
* | --- |
* | "Continue an existing codebase" |
*
* @param {Mk_Tb_Code_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_code_title = /** @type {((inputs?: Mk_Tb_Code_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Code_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_code_title(inputs)
	return en_mk_tb_code_title(inputs)
});